import { Charts } from './Charts';
import SpecialCareChartsDataProvider from './contexts/SpecialCareChartsDataContext';

const SpecialCareWrapper = () => {
    return (
        <SpecialCareChartsDataProvider>
            <Charts />
        </SpecialCareChartsDataProvider>
    );
};

export default SpecialCareWrapper;
